import { render, staticRenderFns } from "./recordCell.vue?vue&type=template&id=fef4755c&scoped=true&"
import script from "./recordCell.vue?vue&type=script&lang=js&"
export * from "./recordCell.vue?vue&type=script&lang=js&"
import style0 from "./recordCell.vue?vue&type=style&index=0&lang=less&"
import style1 from "./recordCell.vue?vue&type=style&index=1&id=fef4755c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef4755c",
  null
  
)

export default component.exports